import { BACKEND_URL_STORE } from '@constants/server.constant'
import { medusaRequest } from '@lib/config'

export const sendMailNewSubscription = async (email: string) =>
  await medusaRequest('POST', `${BACKEND_URL_STORE}/subscription/new`, {
    email
  })
